/**
 * Utility functions for React Query retry configuration
 * Handles authentication token refresh scenarios
 */

/**
 * Standard retry configuration for authentication-dependent queries
 * Retries on 401 errors (expired tokens) up to 2 times to allow axios interceptor
 * to refresh the token via Supabase auth session refresh
 */
export const authRetryConfig = {
  retry: (failureCount: number, error: any) => {
    // Retry on 401 errors (expired token) up to 2 times
    // This allows the axios interceptor to refresh the token
    if (error?.status === 401 && failureCount < 2) {
      return true;
    }
    return false;
  },
  retryDelay: (attemptIndex: number) => Math.min(1000 * 2 ** attemptIndex, 3000), // Exponential backoff
};

/**
 * Conservative retry configuration for less critical queries
 * Single retry attempt on authentication errors
 */
export const lightRetryConfig = {
  retry: (failureCount: number, error: any) => {
    if (error?.status === 401 && failureCount < 1) {
      return true;
    }
    return false;
  },
  retryDelay: 1500, // Fixed delay
};